"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.clrc = clrc;
exports.setc = setc;
exports.clrv = clrv;
exports.setv = setv;
function clrc(flags) {
    flags.c = false;
}
function setc(flags) {
    flags.c = true;
}
function clrv(flags) {
    flags.v = false;
}
function setv(flags) {
    flags.v = true;
}
//# sourceMappingURL=flags.js.map